import AntUpload, { type UploadProps as AntUploadProps } from "antd/lib/upload";

export type UploadProps = AntUploadProps;

const UploadComponent = (props: UploadProps) => {
    return <AntUpload {...props} />;
};

export const Upload = Object.assign(UploadComponent, {
    Dragger: AntUpload.Dragger,
    LIST_IGNORE: AntUpload.LIST_IGNORE,
});
